import { render, staticRenderFns } from "./riskAssessmentAction.vue?vue&type=template&id=03a855ed&scoped=true"
import script from "./riskAssessmentAction.vue?vue&type=script&lang=js"
export * from "./riskAssessmentAction.vue?vue&type=script&lang=js"
import style0 from "./riskAssessmentAction.vue?vue&type=style&index=0&id=03a855ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a855ed",
  null
  
)

export default component.exports